export default __webpack_public_path__ + "static/media/chrome.8b783444.svg";